/**
 * Roll history API service.
 *
 * Paths omit the `/api` prefix (the base URL already includes `/api` via
 * runtime config), matching the other frontend services.
 */

import type { RollHistoryEntry } from '@covered-calls/shared';
import { apiClient } from './api-client';

/**
 * Fetch the recorded roll history for a position.
 */
export async function getRollHistory(positionId: string): Promise<RollHistoryEntry[]> {
  return apiClient.get<RollHistoryEntry[]>(`/trades/${positionId}/roll-history`);
}
